import { generateQueryKey } from 'query';

// TODO: create query key as const - 82948
export const getUserNodeQuery = ({ railsId }: { railsId: string }) => generateQueryKey(['users', 'node', railsId]);
